import React from 'react';
import { withTheme } from 'styled-components';
export var ConsumoIcon = function ConsumoIcon(_ref) {
  var theme = _ref.theme;
  return React.createElement("svg", {
    width: "288px",
    height: "264px",
    viewBox: "0 0 288 264",
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg"
  }, React.createElement("title", null, "Consumo"), React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, React.createElement("g", {
    id: "Consumo",
    transform: "translate(-38.000000, -2.000000)",
    stroke: theme.colors.primary,
    strokeWidth: "15"
  }, React.createElement("g", {
    id: "Comercio",
    transform: "translate(45.000000, 9.000000)"
  }, React.createElement("g", {
    id: "Shopping-E-commerce__x2F__Baskets__x2F__shopping-basket-1_2_"
  }, React.createElement("g", {
    id: "Group_126_2_"
  }, React.createElement("g", {
    id: "shopping-basket-1_2_"
  }, React.createElement("path", {
    d: "M239.74,240.01 C238.61,245.53 233.75,249.490019 228.12,249.490019 L46.15,249.490019 C40.52,249.5 35.66,245.53 34.53,240.01 L12.75,131.02 L261.52,131.02 L239.74,240.01 Z",
    id: "Shape_977_2_"
  }), React.createElement("path", {
    d: "M0.9,107.33 C0.9,100.79 6.2,95.48 12.75,95.48 L261.52,95.48 C268.06,95.48 273.37,100.78 273.37,107.33 L273.37,119.18 C273.37,125.72 268.07,131.03 261.52,131.03 L12.75,131.03 C6.21,131.03 0.9,125.73 0.9,119.18 L0.9,107.33 Z",
    id: "Rectangle-path_39_2_"
  }), React.createElement("line", {
    x1: "36.44",
    y1: "71.79",
    x2: "107.52",
    y2: "0.71",
    id: "Shape_978_2_"
  }), React.createElement("line", {
    x1: "237.83",
    y1: "71.79",
    x2: "166.75",
    y2: "0.71",
    id: "Shape_979_2_"
  }), React.createElement("line", {
    x1: "154.9",
    y1: "154.71",
    x2: "154.9",
    y2: "213.94",
    id: "Shape_980_2_"
  }), React.createElement("line", {
    x1: "202.29",
    y1: "154.71",
    x2: "202.29",
    y2: "213.94",
    id: "Shape_981_2_"
  }), React.createElement("line", {
    x1: "119.36",
    y1: "154.71",
    x2: "119.36",
    y2: "213.94",
    id: "Shape_982_2_"
  }), React.createElement("line", {
    x1: "71.98",
    y1: "154.71",
    x2: "71.98",
    y2: "213.94",
    id: "Shape_983_2_"
  }))))))));
};
export default withTheme(ConsumoIcon);